import { DynamicOptionsWithNumberAndSelection as DynamicOptionsWithNumberAndSelectionType } from '../../../../../../types/Survey/Element'
import { DynamicOptionsWithNumberAndSelection as DynamicOptionsWithNumberAndSelectionAnswerType } from '../../../../../../types/Survey/Answer/Element'
import { Props } from './types'
import Core from './Core'
import { useSelector } from 'react-redux'
import props from '../../../../../../redux/props'
import Modal from '../../../../../UI/Modal/Modal'
import Button from '../../../../../UI/Button/Button'
import { useState } from 'react'
const DynamicOptionsWithNumberAndSelection: React.FC<
  Props<DynamicOptionsWithNumberAndSelectionType, DynamicOptionsWithNumberAndSelectionAnswerType>
> = ({ element, answerElement }) => {
  const [show, setShow] = useState(false)
  const toggle = () => setShow(!show)
  const t = useSelector((s) => s[props.TRANSLATION])
  return (
    <div>
      <Core element={element} />
      <Button small className="mt-3 ml-auto" text={t.survey.analysis.averageValues.sliderDropdownGroup.showDetail} onClick={toggle} />
      <Modal large noForm show={show} onClose={toggle} title={element.title}>
        <div className="flex flex-col gap-3">
          {answerElement.dynamicOptionsWithNumberAndSelection
            .filter((o) => !!o.isActive)
            .map((o, i) => (
              <div key={o.uuid} className="flex gap-2">
                <div className="w-2/4 flex gap-1">
                  <div>{`${i + 1}. `}</div>
                  <div>{o.name}</div>
                </div>
                <div className="w-1/4 shrink-0">{`${o.number} ${element.numberSuffix}`}</div>
                <div className="w-1/4 shrink-0">
                  {o.isNormSelected ? element.normLabel : t.survey.analysis.concept.optimization.uebergeordneteBedarfe.byNorm.no}
                </div>
              </div>
            ))}
        </div>
      </Modal>
    </div>
  )
}

export default DynamicOptionsWithNumberAndSelection
